<template>
  <div>
    <div
      @click="onClickAIChatbotImportButton"
      v-aha-emit-action
      name="editor-import-button"
      class="text-center"
      :class="{'disabled': isButtonDisabled}"
    >
      <aha-icon
        v-if="!isUploadingOrImportingSlides"
        name="import"
        width="20"
        height="21"
        viewBox="0 0 24 25"
        class="text-secondary-100"
      />
      <aha-spinner v-if="isUploadingOrImportingSlides" />
      <p class="text-xs pt-1">
        {{ $i18nPresenter.t("Import") }}
      </p>
    </div>
    <aha-tooltip
      v-if="isUploadingFile"
      to="editor-import-button"
      arrow=""
      trigger="mouseenter focus"
      placement="right"
      theme="dark"
      hideTooltipAfterClick
      showIcon
    >
      {{ $i18nPresenter.t("Uploading your file…") }}
    </aha-tooltip>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'AIChatbotImportButton',

  props: {
    isSelectMode: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters('aiChatbotImportPptxPdf', ['isCurrentPresentationImportingSlides', 'isUploadingFile', 'isUploadingOrImportingSlides']),

    isButtonDisabled() {
      return this.isSelectMode && this.isCurrentPresentationImportingSlides
    },
  },
  methods: {
    ...mapActions('aiChatbotImportPptxPdf', ['setIsAIChatbotImportModalVisibleAction']),

    onClickAIChatbotImportButton() {
      this.setIsAIChatbotImportModalVisibleAction(true)
    },
  },
}
</script>
